import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';

import { routes } from './app.routes';
import { ThemeService } from '@services/theme/theme.service';
import { provideHttpClient, withInterceptors, withXhr } from "@angular/common/http";
import {authInterceptor} from "@interceptors/auth.interceptor";
import {loadingInterceptorFunctional} from "@interceptors/loading.interceptor";

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideAppInitializer(() => {
      inject(ThemeService);
    }),
    provideRouter(routes, withInMemoryScrolling({ anchorScrolling: 'enabled' })),
    provideHttpClient(withXhr(), withInterceptors([authInterceptor, loadingInterceptorFunctional])),

  ]
};
